var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Core
import React from 'react';
// Date
import MomentUtils from '@date-io/moment';
// Material ui
import { Box, Button, Card, Input, Popover, TextField, Typography, createStyles, makeStyles } from '@material-ui/core';
import { CalendarTodayOutlined, RoomOutlined } from '@material-ui/icons';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import moment from 'moment';
import { AutocompleteDigiMaps } from '../AutocompleteDigiMaps';
var useStyle = makeStyles(function (theme) {
    return createStyles({
        btn: function (props) { return ({
            '&:hover': {
                backgroundColor: !props.black ? theme.palette.primary.dark : theme.palette.grey[800],
                color: theme.palette.common.white,
            },
            backgroundColor: !props.black ? theme.palette.primary.main : theme.palette.grey[900],
            borderRadius: 0,
            boxShadow: 'none',
            color: theme.palette.common.white,
            fontSize: theme.typography.body1.fontSize,
            width: 140,
        }); },
        card: {
            borderRadius: theme.shape.borderRadius,
        },
        inputContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            lineHeight: theme.typography.body1.lineHeight,
            padding: theme.spacing(1),
            paddingLeft: theme.spacing(4),
            paddingRight: theme.spacing(4),
        },
        inputs: {
            color: theme.palette.grey[600],
            fontStyle: 'italic',
            fontWeight: 300,
        },
        label: {
            paddingLeft: theme.spacing(1),
            paddingTop: theme.spacing(1),
        },
        labelContainer: {
            color: theme.palette.grey[800],
        },
        root: {
            padding: theme.spacing(0),
        },
        separator: {
            backgroundColor: theme.palette.grey[400],
            marginBottom: theme.spacing(1),
            marginTop: theme.spacing(1),
            width: 1,
        },
        btnSubmit: {
            textTransform: 'capitalize',
        },
    });
});
var DEFAULT_MIN_DATE = { value: 6, unit: 'days' };
var DEFAULT_MAX_DATE = { value: 1, unit: 'years' };
/**
 * SearchBar component
 * @param black
 * @param onSearch
 * @param onLocationChange
 */
var SearchBar = function (_a) {
    var black = _a.black, onSearch = _a.onSearch, initialValues = _a.initialValues, _b = _a.minDate, minDate = _b === void 0 ? DEFAULT_MIN_DATE : _b, _c = _a.maxDate, maxDate = _c === void 0 ? DEFAULT_MAX_DATE : _c;
    /** Component states */
    var _d = React.useState({
        location: initialValues ? initialValues.location : undefined,
        anchorElfrom: null,
        anchorElto: null,
        from: initialValues ? moment(initialValues.from) : undefined,
        fromOpen: false,
        to: initialValues ? moment(initialValues.to) : undefined,
        toOpen: false,
    }), state = _d[0], setState = _d[1];
    /** Constant */
    var buttonSearchDisable = !state.location || !state.to || !state.from;
    /** Component styles */
    var styles = useStyle({ black: black });
    /**
     * Handle submit on button search click
     */
    var handleSubmit = function () {
        if (state.from && state.to && state.location) {
            onSearch(state.location, state.from.toDate(), state.to.toDate());
        }
    };
    /**
     * Handle date change after user date selection with datepicker
     * @param id
     */
    var handleDate = function (id) {
        return function (date) {
            var _a;
            if (id === 'to' && date && date.isSame(state.from, 'date')) {
                return;
            }
            var reset = { fromOpen: false, toOpen: false };
            setState(__assign(__assign(__assign({}, state), (_a = {}, _a[id] = date, _a)), reset));
        };
    };
    /**
     * Handle location change on input change event
     * @param selectedPlace
     */
    var handleSelectPlace = function (selectedPlace) {
        setState(__assign(__assign({}, state), { location: selectedPlace }));
    };
    /**
     * Open datepicker on input click
     * @param id
     */
    var openDatepicker = function (id) {
        return function (e) {
            var _a;
            e.persist();
            setState(__assign(__assign({}, state), (_a = {}, _a["anchorEl" + id] = e.target, _a[id + "Open"] = true, _a)));
        };
    };
    /**
     * Format date for input text element display
     * @param prefix
     * @param date
     */
    var formatedDate = function (prefix, date) { return (date ? prefix + " " + date.format('DD/MM') : ''); };
    var toMinDate = state.from ? moment(state.from).add(1, 'days') : moment().add(1, 'days');
    var toMaxDate = moment().add(maxDate.value, maxDate.unit);
    var fromMinDate = moment().add(minDate.value, minDate.unit);
    var fromMaxDate = state.to ? moment(state.to).add(-1, 'days') : undefined;
    return (React.createElement(Card, null,
        React.createElement(MuiPickersUtilsProvider, { utils: MomentUtils },
            React.createElement(Box, { display: "flex" },
                React.createElement(Box, { flexGrow: 1 },
                    React.createElement(Box, { className: styles.inputContainer },
                        React.createElement(Box, { width: "30%", minWidth: 200 },
                            React.createElement(Box, { display: "flex", alignItems: "center", className: styles.labelContainer },
                                React.createElement(RoomOutlined, null),
                                React.createElement(Typography, { className: styles.label }, "O\u00F9 ?")),
                            React.createElement(AutocompleteDigiMaps, { InputRender: TextField, InputProps: {
                                    fullWidth: true,
                                    placeholder: 'Ex: Lyon',
                                    className: styles.inputs,
                                }, place: state.location, onSelect: handleSelectPlace })),
                        React.createElement(Box, { className: styles.separator }),
                        React.createElement(Box, { width: "45%" },
                            React.createElement(Box, { display: "flex", alignItems: "center", className: styles.labelContainer },
                                React.createElement(CalendarTodayOutlined, { className: "azzae" }),
                                React.createElement(Typography, { className: styles.label }, "Quand ?")),
                            React.createElement(Box, { display: "flex" },
                                React.createElement(Input, { className: styles.inputs, disableUnderline: true, value: formatedDate('Du', state.from), placeholder: "Du", onClick: openDatepicker('from') }),
                                React.createElement(Input, { className: styles.inputs, disableUnderline: true, value: formatedDate('Au', state.to), placeholder: "Au", onClick: openDatepicker('to') }),
                                React.createElement(Popover, { open: state.fromOpen, anchorEl: state.anchorElfrom, anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }, transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }, onBackdropClick: function () { return setState(__assign(__assign({}, state), { fromOpen: false })); }, onClick: function (e) { return e.stopPropagation(); } },
                                    React.createElement(DatePicker, { variant: "static", orientation: "landscape", value: state.from, minDate: fromMinDate, maxDate: fromMaxDate, disablePast: true, onChange: handleDate('from') })),
                                React.createElement(Popover, { open: state.toOpen, anchorEl: state.anchorElto, anchorOrigin: {
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                    }, transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'center',
                                    }, onBackdropClick: function () { return setState(__assign(__assign({}, state), { toOpen: false })); }, onClick: function (e) { return e.stopPropagation(); } },
                                    React.createElement(DatePicker, { variant: "static", orientation: "landscape", value: state.to, minDate: toMinDate, maxDate: toMaxDate, disablePast: true, initialFocusedDate: toMinDate, onChange: handleDate('to') })))))),
                React.createElement(Button, { variant: "contained", className: styles.btn + " " + styles.btnSubmit, onClick: handleSubmit, disabled: buttonSearchDisable }, "Rechercher")))));
};
export default SearchBar;
//# sourceMappingURL=index.js.map